var ValueJS = ValueJS || {};

ValueJS.LazyLoad = function() {

    var _loader;
    var _initialized = false;

    var _init = function() {
        if (!_initialized) {
            // initialize lazy loader
            _loader = new LazyLoad({});
            _initialized = true;
        }
    }

    var _domUpdate = function() {
        _loader.update();
    }

    /** PUBLIC API **/
    return {
        init : function() {return _init();},
        domUpdate : function() {return _domUpdate();}
    };

}();

$(function() {
    ValueJS.LazyLoad.init();
});
